/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S1_Subscriber_BodyInputs */

const tr_mesafeli_s1_subscriber_body = /** @type {(inputs: Mesafeli_S1_Subscriber_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform'a kayıt olarak işbu Sözleşme'yi elektronik ortamda kabul eden gerçek veya tüzel kişi.`)
};

const en_mesafeli_s1_subscriber_body = /** @type {(inputs: Mesafeli_S1_Subscriber_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The natural or legal person who registers on the Platform and accepts this Agreement electronically.`)
};

const de_mesafeli_s1_subscriber_body = /** @type {(inputs: Mesafeli_S1_Subscriber_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natürliche oder juristische Person, die sich auf der Plattform registriert und diesen Vertrag auf elektronischem Wege annimmt.`)
};

const ru_mesafeli_s1_subscriber_body = /** @type {(inputs: Mesafeli_S1_Subscriber_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Физическое или юридическое лицо, которое регистрируется на Платформе и принимает настоящий Договор в электронной форме.`)
};

/**
* | output |
* | --- |
* | "The natural or legal person who registers on the Platform and accepts this Agreement electronically." |
*
* @param {Mesafeli_S1_Subscriber_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s1_subscriber_body = /** @type {((inputs?: Mesafeli_S1_Subscriber_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S1_Subscriber_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s1_subscriber_body(inputs)
	if (locale === "de") return de_mesafeli_s1_subscriber_body(inputs)
	if (locale === "ru") return ru_mesafeli_s1_subscriber_body(inputs)
	return tr_mesafeli_s1_subscriber_body(inputs)
});